import InvownTooltip from "@/components/post-close/InvownTooltip.vue";
import tooltipData from "@/data/tooltips.json";

const TooltipPlugin = {
  install(Vue) {
    Vue.component("InvownTooltip", InvownTooltip);

    Vue.prototype.$tooltip = function (id) {
      return tooltipData[id] || null;
    };
  },
};

export default TooltipPlugin;
